module.exports = __webpack_public_path__ + "media/images/cabecera2-10237d73.png";